import { useMemo } from "react";
import { ReactFlow, Controls, Background, Handle, Position } from "reactflow";
import "reactflow/dist/style.css";
import { Box, Paper, Typography } from "@mui/material";
import ClaimStatusBadge from "../../../components/ClaimStatusBadge.jsx";
import {
  BACK_EDGE_COLOR,
  NODE_HEIGHT,
  STATE_WIDTH,
  buildDiagram,
} from "./buildWorkflowDiagram.js";

const handle_style = { opacity: 0 };

// Status in den Farben der Schadenliste, damit sich Diagramm und Liste zuordnen lassen.
function StateNode({ data }) {
  return (
    <Box
      sx={{
        width: STATE_WIDTH,
        minHeight: NODE_HEIGHT,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Handle type="target" position={Position.Top} style={handle_style} />
      <Handle
        id="back-in"
        type="target"
        position={Position.Left}
        style={handle_style}
      />
      <ClaimStatusBadge status={data.value} label={data.label} size="medium" />
      <Handle type="source" position={Position.Bottom} style={handle_style} />
      <Handle
        id="back-out"
        type="source"
        position={Position.Left}
        style={handle_style}
      />
    </Box>
  );
}

function PhaseFrame({ data }) {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        border: "1px dashed #9e9e9e",
        borderRadius: 2,
        bgcolor: "rgba(0,0,0,0.03)",
      }}
    >
      <Box display="flex" justifyContent="space-between" px={1.5} py={0.5}>
        <Typography variant="caption" fontWeight={600}>
          {data.label}
        </Typography>
        {data.note && (
          <Typography variant="caption" sx={{ color: BACK_EDGE_COLOR }}>
            {data.note}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

const nodeTypes = {
  phase: PhaseFrame,
  state: StateNode,
};

export default function WorkflowDiagram({ states, transitions }) {
  const { nodes, edges } = useMemo(
    () => buildDiagram(states, transitions),
    [states, transitions]
  );

  return (
    <Paper variant="outlined" sx={{ height: 650 }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        fitView
        nodesDraggable={false}
        nodesConnectable={false}
      >
        <Controls showInteractive={false} />
        <Background color="#aaa" gap={16} />
      </ReactFlow>
    </Paper>
  );
}
